const Status = {
  LOADING: 'loading',
  SUCCESS: 'success',
  FAILURE: 'failure'
}

export default (state = {payLog: [], loginLog: []}, action) => {
  switch(action.type) {
    case 'PAYLOG_STARTED': {
      return {...state, payStatus: Status.LOADING}
    }
    case 'PAYLOG_SUCCESS': {
      const result = action.result.reverse()
      return {...state, payStatus: Status.SUCCESS, payLog: result}
    }
    case 'PAYLOG_FAILURE': {
      return {...state, payStatus: Status.FAILURE}
    }
    case 'LOGINLOG_STARTED': {
      return {...state, loginStatus: Status.LOADING}
    }
    case 'LOGINLOG_SUCCESS': {
      const result = action.result.reverse()
      return {...state, loginStatus: Status.SUCCESS, loginLog: result}
    }
    case 'LOGINLOG_FAILURE': {
      return {...state, loginStatus: Status.FAILURE}
    }
    default: {
      return state
    }
  }
}


// WEBPACK FOOTER //
// ./src/modules/log/reducer.js